export default ({ Vue }) => {
  // eslint-disable-next-line no-extend-native
  Vue.filter('validateEmail', function (email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(String(email).toLowerCase())
  })
  Vue.filter('validatePassword', function (password) {
    const re = /^(?=.*\d)(?=.*[a-z]).{8,}$/
    return re.test(String(password))
  })
}
